import toast from "react-hot-toast";

export const handleApiError = (error) => {
    const message = error?.response?.data?.error?.message || error?.response?.data?.message;
    toast.error(message);
};
